<template>
  <div class="index_content" v-if="indexData.style" :style="'position: relative;background-image:url('+oss+indexData.style.backgroundImage+');background-color:'+indexData.style.backgroundColor">
    <div class="content">
      <slot name="indexContent"></slot>
    </div>
  </div>
</template>
<script>
import config from '@/config'
export default {
  props:{
    indexData:Object
  },
  setup() {
    const oss=config.oss[process.env.VUE_APP_type]
    return{
      oss
    }
  }
}
</script>
<style lang="less" scoped>
.index_content{
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  overflow:auto;
  .content{
    height: 100%;
  }
}
</style>